import { isPrimaryOrSecondaryColor } from '../../utils';
import { ComponentStyleConfig } from '@chakra-ui/react';
import { mode, StyleFunctionProps } from '@chakra-ui/theme-tools';

const SearchBox: ComponentStyleConfig = {
  parts: ['InputGroup', 'Input', 'InputRightAddon', 'Button', 'Icon'],
  baseStyle: (props: StyleFunctionProps) => ({
    InputGroup: {
      bg: mode('white', 'gray.800'),
      _focus: { boxShadow: 'unset' },
      w: props.size ? props.size : 'lg',
    },
    Input: {
      fontSize: 'sm',
      borderColor: mode('gray.300', 'gray.800')(props),
      textColor: mode('gray.700', 'gray.600')(props),
      _focus: {
        borderColor: isPrimaryOrSecondaryColor(props.colorScheme)
          ? props.colorScheme
          : mode(`${props.colorScheme}.600`, `${props.colorScheme}.400`)(props),
        borderWidth: 3,
      },
    },
    InputRightAddon: {
      borderLeftRadius: 'none',
      borderColor: mode('gray.300', 'gray.800')(props),
    },
    Button: {
      height: '30px',
      bg: mode('gray.100', 'gray.800')(props),
      color: mode('black', 'white')(props),
      _focus: {
        transform: 'scale(0.98)',
        border: '2px solid',
        borderColor: isPrimaryOrSecondaryColor(props.colorScheme || '')
          ? props.colorScheme
          : `${props.colorScheme}.600`,
      },
    },
    Icon: {
      w: 'full',
      m: 2,
    },
  }),
  variants: {
    bordered: () => ({
      Input: {
        borderRadius: 6,
        border: '1px',
      },
    }),
    'round-bordered': () => ({
      Input: {
        borderRadius: 'full',
        border: '1px solid',
      },
      InputRightAddon: {
        borderRadius: 'full',
        border: '1px solid',
      },
    }),
    ghost: (props) => ({
      Input: {
        borderRadius: 6,
        border: '2px solid',
        shadow: mode('lg', 'none')(props),
      },
      InputRightAddon: {
        border: '2px solid',
        shadow: mode('lg', 'none')(props),
      },
    }),
    'ghost-rounded': (props) => ({
      Input: {
        borderRadius: 'full',
        border: '2px solid',
        shadow: mode('lg', 'none')(props),
      },
      InputRightAddon: {
        borderRadius: 'full',
        border: '2px solid',
        shadow: mode('lg', 'none')(props),
      },
    }),
  },
  defaultProps: {
    variant: 'bordered',
    size: 'lg',
    colorScheme: 'primary',
  },
};
export default SearchBox;
